import React, { useEffect, useState } from 'react';
import { error as logAppInsightError } from '../../utils/logger';
import { logError } from "../../utils/logError";
import "../../common.css"
import { getAccessToken } from "../../services/authApi";
import { getUserDetails, getTpoSettingsAllBasicInfo } from "../../services/userApi";
import elliemaeApi from '../../services/interceptors/elliemaeApi';
import { getOrgConfig } from '../../utils/organizationConfigUtil';

const LenderContacts = () => {
    const [contacts, setContacts] = useState([]);
    const [corrContacts, setCorrContacts] = useState([]);
    const [orgID, setOrgID] = useState('');
    const [channelTypes, setChannelTypes] = useState([]);
    const [correspondentSelection, setCorrespondentSelection] = useState([]);

    useEffect(() => {
        if (window.elli && window.elli.script && window.elli.script.guest) {
            window.elli.script.guest.create();
            initializeAuthObject();
        } else {
            console.warn("elli.script.guest is not available.");
        }
    }, []);

    const initializeAuthObject = async () => {
        try {
            window.elli.script.getObject("tpoApplication").then(async function (tpoApplicationObject) {
                const tpoAppObject = tpoApplicationObject;

                tpoAppObject.getExternalOrgDetails().then(async function (extOrg) {
                    let allContacts = [];
                    let allCorrContacts = [];
                    setOrgID(extOrg.companyOrgId);

                    try {
                        const authObject = await window.elli.script.getObject("auth");

                        //Channel selection
                        try {
                            const authCode = await authObject.createAuthCode();
                            const token = await getAccessToken(authCode);
                            if (token) {

                                await authObject.getUser().then(async function (user) {
                                    try {
                                        console.log(user.id);
                                        const authCodes = await authObject.createAuthCode();
                                        // 1) Call getUserDetails on page load (after auth)
                                        const userDetails = await getUserDetails(token, user.id);
                                        // Get orgId from userDetails.organization.entityId
                                        const orgId = userDetails?.organization?.entityId;

                                        // 2) Call TPO settings endpoint using orgId
                                        const tpoSettings = await getTpoSettingsAllBasicInfo(token, orgId);

                                        // Call the new function with params from company
                                        // Set channel types (array)
                                        const channels = tpoSettings?.companyDetails?.channels ?? [];
                                        setChannelTypes(channels);
                                        setCorrespondentSelection(tpoSettings?.companyDetails?.underwritingTypes ?? []);
                                        console.log("Channel Types:", tpoSettings?.companyDetails?.channels);
                                        console.log("Underwriting Types:", tpoSettings?.companyDetails?.underwritingTypes);
                                    } catch (e) {
                                        console.error("UserDetails/TPO basicInfo check failed:", e);
                                        // set setChannelTypes as broker as default
                                        setChannelTypes("Broker");
                                    }
                                });
                            }

                        } catch (error) {
                            console.error("createAuthCode Error:", error);
                        }


                        const authCode = await authObject.createAuthCode();
                        const accessToken = await getAccessToken(authCode);

                        const url = `/encompass/v1/externalOrganizations/tpos/${extOrg?.companyOrgId}/companyContacts`;
                        const response = await elliemaeApi.get(
                            url,
                            {
                                headers: {
                                    Authorization: `Bearer ${accessToken}`,
                                    'Content-Type': 'application/json',
                                },
                            }
                        );

                        if (response.status == 200) {
                            // 🔹 1. Get ONLY primary Account Executive
                            /*Removed as per new requirements
                            const accountExecutive = response?.data?.find(
                                c =>
                                    c?.isPrimarySalesRep === true
                            );
                            if (accountExecutive) {
                                allContacts.push({
                                    role: "Account Executive",
                                    userName: accountExecutive.entityName,
                                    email: accountExecutive.entityData?.email || "",
                                    phone: accountExecutive.entityData?.phone || "",
                                });
                            }*/

                            // 🔹 2. Add static contacts 
                            allContacts = getOrgConfig().allContacts;
                            allCorrContacts = getOrgConfig().allCorrContacts;
                        }
                    } catch (err) {
                        console.error("Error fetching AE:", err);
                    }

                    // 🔹 3. Sort in fixed order
                    const roleOrder = [
                        "Account Executive",
                        "Scenarios Desk",
                        "Client Approval"
                    ];
                    const sortedContacts = allContacts.sort(
                        (a, b) => roleOrder.indexOf(a.role) - roleOrder.indexOf(b.role)
                    );

                    setContacts(sortedContacts);
                    setCorrContacts(allCorrContacts);

                });
            });
        } catch (error) {
            const errorCode = logError("LOAN_SUMMARY_ERROR");
            logAppInsightError("Lender Key Contacts Initialization Failed", {
                component: "LenderKeyContacts",
                problemId: errorCode,
                errorCode,
                rawError: error,
                errorMessage: `${errorCode} - Failed to load Lender Key Contacts Information.`,
            });
        }
    };


    const renderMilestoneContacts = () => {
        if (!contacts.length || !corrContacts.length) return null;

        // If more than one channel type, show both sections
        if (Array.isArray(channelTypes) && channelTypes.length > 1) {
            return (
                <>
                    <div className="bg-white border border-gray-300 rounded-sm min-h-[200px]" >
                        {/* Header */}
                        <div className="px-4 py-3 border-b lenderkey-header bg-gray-100"
                            style={{
                                background: '#f8f9f9',
                                borderBottom: '1px solid #d1d5db'
                            }}>
                            Wholesale Key Contacts
                        </div>
                        {/* Rows */}
                        {contacts.map((c, idx) => (
                            <div
                                key={`broker-${idx}`}
                                className={`px-4 py-3 ${idx !== contacts.length - 1 ? "border-b" : ""}`}
                                style={{
                                    height: 'auto',
                                    background: '#ffffff',
                                }}
                            >
                                <div className="lenderkey-role">
                                    {c.role}
                                </div>
                                {c.userName && (
                                    <div className="lenderkey-details">
                                        {c.userName}
                                    </div>
                                )}
                                {c.email && (
                                    <div className="lenderkey-details">
                                        <a
                                            href={`mailto:${c.email}`}
                                            className="text-blue-600 hover:text-blue-600 visited:text-blue-600 active:text-blue-600 focus:text-blue-600 hover:underline"
                                        >
                                            {c.email}
                                        </a>
                                    </div>
                                )}
                                {c.phone && (
                                    <div className="lenderkey-details">
                                        {c.phone}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    <div className="bg-white border border-gray-300 rounded-sm min-h-[200px] mt-6" >


                        {/* Header */}
                        <div className="px-4 py-3 border-b lenderkey-header bg-gray-100"
                            style={{
                                background: '#f8f9f9',
                                borderBottom: '1px solid #d1d5db'
                            }}>
                            Correspondent Key Contacts
                        </div>
                        {/* Rows */}
                        {corrContacts.map((c, idx) => (
                            <div
                                key={`correspondent-${idx}`}
                                className={`px-4 py-3 ${idx !== corrContacts.length - 1 ? "border-b" : ""}`}
                                style={{
                                    height: 'auto',
                                    background: '#ffffff',
                                }}
                            >
                                <div className="lenderkey-role">
                                    {c.role}
                                </div>
                                {c.userName && (
                                    <div className="lenderkey-details">
                                        {c.userName}
                                    </div>
                                )}
                                {c.email && (
                                    <div className="lenderkey-details">
                                        <a
                                            href={`mailto:${c.email}`}
                                            className="text-blue-600 hover:text-blue-600 visited:text-blue-600 active:text-blue-600 focus:text-blue-600 hover:underline"
                                        >
                                            {c.email}
                                        </a>
                                    </div>
                                )}
                                {c.phone && (
                                    <div className="lenderkey-details">
                                        {c.phone}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </>
            );
        }

        // If only one channel type, show the relevant section
        if (channelTypes === "Correspondent" || (Array.isArray(channelTypes) && channelTypes[0] === "Correspondent")) {
            return (
                <div className="bg-white border border-gray-300 rounded-sm min-h-[400px]" >
                    {/* Header */}
                    <div className="px-4 py-3 border-b lenderkey-header bg-gray-100"
                        style={{
                            background: '#f8f9f9',
                            borderBottom: '1px solid #d1d5db'
                        }}>
                        Correspondent Key Contacts
                    </div>
                    {/* Rows */}
                    {corrContacts.map((c, idx) => (
                        <div
                            key={idx}
                            className={`px-4 py-3 ${idx !== corrContacts.length - 1 ? "border-b" : ""}`}
                            style={{
                                height: 'auto',
                                background: '#ffffff',
                            }}
                        >
                            <div className="lenderkey-role">
                                {c.role}
                            </div>
                            {c.userName && (
                                <div className="lenderkey-details">
                                    {c.userName}
                                </div>
                            )}
                            {c.email && (
                                <div className="lenderkey-details">
                                    <a
                                        href={`mailto:${c.email}`}
                                        className="text-blue-600 hover:text-blue-600 visited:text-blue-600 active:text-blue-600 focus:text-blue-600 hover:underline"
                                    >
                                        {c.email}
                                    </a>
                                </div>
                            )}
                            {c.phone && (
                                <div className="lenderkey-details">
                                    {c.phone}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            );
        }
        if (channelTypes === "Broker" || (Array.isArray(channelTypes) && channelTypes[0] === "Broker")) {
            return (
                <div className="bg-white border border-gray-300 rounded-sm min-h-[400px]" >
                    {/* Header */}
                    <div className="px-4 py-3 border-b lenderkey-header bg-gray-100"
                        style={{
                            background: '#f8f9f9',
                            borderBottom: '1px solid #d1d5db'
                        }}>
                        Wholesale Key Contacts
                    </div>
                    {/* Rows */}
                    {contacts.map((c, idx) => (
                        <div
                            key={idx}
                            className={`px-4 py-3 ${idx !== contacts.length - 1 ? "border-b" : ""}`}
                            style={{
                                height: 'auto',
                                background: '#ffffff',
                            }}
                        >
                            <div className="lenderkey-role">
                                {c.role}
                            </div>
                            {c.userName && (
                                <div className="lenderkey-details">
                                    {c.userName}
                                </div>
                            )}
                            {c.email && (
                                <div className="lenderkey-details">
                                    <a
                                        href={`mailto:${c.email}`}
                                        className="text-blue-600 hover:text-blue-600 visited:text-blue-600 active:text-blue-600 focus:text-blue-600 hover:underline"
                                    >
                                        {c.email}
                                    </a>
                                </div>
                            )}
                            {c.phone && (
                                <div className="lenderkey-details">
                                    {c.phone}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            );
        }
        return null;
    };



    return (

        <div>
            {renderMilestoneContacts()}
        </div>
    );
};
export default LenderContacts;